/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BulkQuantityDiscountSynchronizeRequest } from '../../models/bulk-quantity-discount-synchronize-request';
import { BulkQuantityDiscountSynchronizeResponse } from '../../models/bulk-quantity-discount-synchronize-response';

export interface BulkQuantityDiscountSynchronize$Params {
      body: BulkQuantityDiscountSynchronizeRequest
}

export function bulkQuantityDiscountSynchronize(http: HttpClient, rootUrl: string, params: BulkQuantityDiscountSynchronize$Params, context?: HttpContext): Observable<StrictHttpResponse<BulkQuantityDiscountSynchronizeResponse>> {
  const rb = new RequestBuilder(rootUrl, bulkQuantityDiscountSynchronize.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BulkQuantityDiscountSynchronizeResponse>;
    })
  );
}

bulkQuantityDiscountSynchronize.PATH = '/discounts/bulk-synchronize';
